import { render, staticRenderFns } from "./DashboardCollectionTile.vue?vue&type=template&id=ddf1d60c&scoped=true&"
import script from "./DashboardCollectionTile.vue?vue&type=script&lang=ts&"
export * from "./DashboardCollectionTile.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCollectionTile.vue?vue&type=style&index=0&id=ddf1d60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf1d60c",
  null
  
)

export default component.exports